import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

  initialize: function(options) {
    this.cancelPopin = this.cancelPopin.bind(this);
    this.validateEmail = this.validateEmail.bind(this);

    this.alertContactModel = options.alertContactModel;
    this.content = options.content;

    this.alertContactModel.validationOptions.emptyEmailAddressError = 'L\'email ne doit pas être vide.';
    this.listenTo(this.alertContactModel, 'invalid', this.render);

    this.render();

    this.$emailAddress = this.$el.find('#EmailAddress');
    this.$errorMessage = this.$el.find('.js-ChangeMail-errorsList');
  },

  events: {
    'click .js-changeMail-close': 'cancelPopin',
    'click .js-changeMail-close--confirm': 'validateEmail'
  },

  validateEmail: function(e) {
    e.preventDefault();
    var emailAddress = this.$emailAddress.val();
    this.alertContactModel.updateEmail(emailAddress, {
      success: function(model) {
        $.magnificPopup.close();
      },
      error: (model, response, options) => {
        if (response.status === 401) { document.location.href = response; }
        if (response.status === 400) {
          var error = response.responseJSON.ModelState['viewModel.EmailAddress'];
          this.render(null, error);
        }
      }
    });
  },

  render: function(model, error) {

    if (error) {
      this.$errorMessage.html(error);
      this.$errorMessage.removeClass('hide');
      return;
    }

    if (this.$errorMessage && this.$errorMessage.hasClass('hide')) {
      this.$errorMessage.removeClass('hide');
    }

    if (this.content && this.content.length) {
      this.$el.html(this.content.html());
      this.content = null;
    }
  },

  cancelPopin: function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  }

});
